import { render, staticRenderFns } from "./DownloadUsbAgent.vue?vue&type=template&id=0b620772&scoped=true"
import script from "./DownloadUsbAgent.vue?vue&type=script&lang=ts"
export * from "./DownloadUsbAgent.vue?vue&type=script&lang=ts"
import style0 from "./DownloadUsbAgent.vue?vue&type=style&index=0&id=0b620772&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b620772",
  null
  
)

export default component.exports